import { render, staticRenderFns } from "./userMarketplace.vue?vue&type=template&id=9fb7aed0&scoped=true&"
import script from "./userMarketplace.vue?vue&type=script&lang=js&"
export * from "./userMarketplace.vue?vue&type=script&lang=js&"
import style0 from "./userMarketplace.vue?vue&type=style&index=0&id=9fb7aed0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fb7aed0",
  null
  
)

export default component.exports